import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUsersAPI } from '../Action/api';

// ---------------------------------------------------------------------------
// Async thunk
// ---------------------------------------------------------------------------
export const fetchUsersData = createAsyncThunk(
  'users/fetchUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUsersAPI();
      if (response?.data?.status) {
        return response.data.users;
      }
      return rejectWithValue(response?.data?.message || 'Failed to fetch users');
    } catch (err) {
      return rejectWithValue(err?.message || 'Error loading users');
    }
  }
);

// ---------------------------------------------------------------------------
// Slice
// ---------------------------------------------------------------------------
const usersSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    /** 'idle' | 'loading' | 'succeeded' | 'failed' */
    status: 'idle',
    error: null,
    lastFetchedAt: null,
  },
  reducers: {
    /**
     * Mark the list as stale so the next mount triggers a fresh API call.
     * Call this before re-dispatching fetchUsersData after a mutation.
     */
    invalidateUsers: (state) => {
      state.status = 'idle';
      state.lastFetchedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersData.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchUsersData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload || [];
        state.lastFetchedAt = Date.now();
        state.error = null;
      })
      .addCase(fetchUsersData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch users';
      });
  },
});

export const { invalidateUsers } = usersSlice.actions;
export default usersSlice.reducer;
